import React from "react";
import { motion } from "framer-motion";
import "./pricing.css";
import PricingComparison from "./PricingComparison";

const Pricing = () => {
  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-container">
        {/* Header */}
        <motion.div
          className="pricing-header"
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Price Guarantee Badge */}
          <div className="price-guarantee-badge">
            <svg
              className="badge-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2L4 7v10c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V7l-8-5z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Price Guarantee</span>
          </div>

          {/* Main Heading */}
          <h2 className="pricing-heading">Most Cost-Effective Guaranteed.</h2>
          <p className="pricing-subtitle">
            Compare us with any competitor. Our quality and economics outperform.
          </p>
        </motion.div>

        {/* Comparison Table */}
        <PricingComparison />
      </div>
    </section>
  );
};

export default Pricing;